import { render, staticRenderFns } from "./TitleSlide.vue?vue&type=template&id=c2f4a40c&lang=pug"
import script from "./TitleSlide.vue?vue&type=script&lang=ts"
export * from "./TitleSlide.vue?vue&type=script&lang=ts"
import style0 from "./TitleSlide.vue?vue&type=style&index=0&id=c2f4a40c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports